import React, { useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { InputText } from 'primereact/inputtext'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { CustomPanel, PageHeader } from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import useBateriaCelularDrive, { LOAD_MESSAGE } from './BateriaCelularDriveHook'
import { formatIsoDateToLocale } from '../../../../services/util/date.service'
import { tableCellCentered } from '../../../../assets/js/styles'

function BateriaCelularDrive({ history, dispatch, selectedTp }) {
  const { state, localDispatch } = useBateriaCelularDrive()
  const {
    location: {
      state: { fleet_id },
    },
  } = history

  useEffect(() => {
    localDispatch.onInit()
  }, [])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.LOADING_DATA:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getBaterias(fleet_id)
        break

      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  const buildDataTable = () => {
    const header = (
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10, width: '100%' }}>
        <div style={{ textAlign: 'left' }}>
          <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }} />
          <InputText
            type="search"
            onInput={e => localDispatch.onInputFilter(e.target.value)}
            placeholder="Pesquisar . . ."
            size="50"
          />
        </div>
      </div>
    )
    return (
      <DataTable
        value={state.baterias}
        paginator={true}
        rows={10}
        header={header}
        globalFilter={state.globalFilter}
      >
        <Column field="vehicle_plate" header="Placa" />
        <Column field="percentage" header="Porcentagem de Bateria" />
        <Column
          field="created_at"
          header="Data"
          body={item => formatIsoDateToLocale(item.created_at).toFormat('dd/MM/yyyy HH:mm:ss')}
          style={tableCellCentered(180)}
        />
      </DataTable>
    )
  }

  return (
    <div>
      <PageHeader>Bateria do Celuar Tp Drive</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={() => history.goBack()}>
          {buildDataTable()}
        </CustomPanel>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(BateriaCelularDrive))
